import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { AppState } from '@nxsys/store';
import { Grid } from 'antd';
import AppSidebar from './AppSidebar';
import AppHeader from './AppHeader';
import AppContentView from '../../AppContentView';
import AppThemeSetting from '../../AppThemeSetting';
import AiChatbot from '../../AiChatbot';
import clsx from 'clsx';
import { FooterType } from '@nxsys/constants/AppEnums';
import { allowAiChatbot } from '@nxsys/constants/AppConst';
import { isEmpty } from '@nxsys/helpers/Common';
import { useLayoutContext } from '@nxsys/context/AppContextProvider/LayoutContextProvider';
import {
  StyledAppLayoutStandard,
  StyledAppLayoutStandardMain,
  StyledAppLayoutStandardRow,
  StyledStandardScrollbar,
} from './index.styled';
import { RouterConfigData } from '@nxsys/types/models/Apps';

const { useBreakpoint } = Grid;

type Props = {
  routes: React.ReactElement | null;
  routesConfig: RouterConfigData[];
};
const Standard: React.FC<Props> = ({ routes, routesConfig }) => {
  const width = useBreakpoint();
  const { isBureau } = useSelector((state: AppState) => state.appStore);
  const [isCollapsed, setCollapsed] = useState(false);
  const { footer, footerType, iframe } = useLayoutContext();

  const onToggleSidebar = () => {
    setCollapsed(!isCollapsed);
  };

  useEffect(() => {
    if (!isEmpty(width)) {
      if (width.xl) {
        setCollapsed(false);
      } else {
        setCollapsed(true);
      }
    }
  }, [width]);

  return (
    <StyledAppLayoutStandard
      className={clsx({
        appMainFooter: footer && footerType === FooterType.FLUID,
        appMainFixedFooter: footer && footerType === FooterType.FIXED,
      })}
    >
      {iframe ? (
        <AppContentView routes={routes} isBureau={isBureau} />
      ) : (
        <>
          <AppHeader
            isCollapsed={isCollapsed}
            onToggleSidebar={onToggleSidebar}
          />
          <StyledAppLayoutStandardRow>
            <AppSidebar isCollapsed={isCollapsed} routesConfig={routesConfig} />
            <StyledAppLayoutStandardMain className="app-layout-standard-main">
              <StyledStandardScrollbar>
                <AppContentView routes={routes} />
              </StyledStandardScrollbar>
            </StyledAppLayoutStandardMain>
          </StyledAppLayoutStandardRow>
          <AppThemeSetting />
        </>
      )}
      {allowAiChatbot && <AiChatbot />}
    </StyledAppLayoutStandard>
  );
};

export default React.memo(Standard);
